export default function InvoiceIcon() {
    return <img src="/assets/images/img_icons8invoice1.svg" alt="Invoices" />
}